import { c as _c } from "react/compiler-runtime";
import { capitalize, MenuItem, Select } from '@mui/material';
import { type Condition } from '@repo/api-gw-sdk';
import { type FilterProperty, PropertyPolicyRelation } from '@/types/advanceFilter';
import { OPERATORS } from './OperatorSelect';

/**
 * Operator picker at the top of a filter chip's panel, offering the same operators as the condition builder's
 * `OperatorSelect`. It keeps the values the condition already holds, though: every operator consumes the same list
 * of values, and the common edit here is flipping a filter to its negation — which would be pointless if it
 * emptied the selection first.
 */
export const FilterOperatorSelect = t0 => {
  const $ = _c(10);
  const {
    condition,
    property,
    onChange
  } = t0;
  const relation = property.policyRelation ?? PropertyPolicyRelation.MultipleValues;
  const t1 = `filter-operator-${property.name}`;
  const t2 = condition.operator ?? "";
  let t3;
  if ($[0] !== condition || $[1] !== onChange) {
    t3 = event => onChange({
      ...condition,
      operator: event.target.value
    });
    $[0] = condition;
    $[1] = onChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== relation) {
    t4 = Object.entries(OPERATORS[relation]).map(_temp);
    $[3] = relation;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <Select fullWidth={true} data-testid={t1} value={t2} onChange={t3}>{t4}</Select>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(t0) {
  const [operator, t1] = t0;
  const {
    label
  } = t1;
  return <MenuItem key={operator} value={operator}>{capitalize(label)}</MenuItem>;
}